// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { addToChainAfter, executeAwaitableHandlerChain, Handler } from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter, GetRelatedProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, LoadRealTimeInventory } from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import loadVariantChildren from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChildren";
import { getVariantChildrenDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

interface Parameter {
    id: string;
    getProductCollectionParameter: GetProductCollectionApiV2Parameter | GetRelatedProductCollectionApiV2Parameter;
    extraProductOptions?: {
        getProductCollectionParameter: GetProductCollectionApiV2Parameter | GetRelatedProductCollectionApiV2Parameter;
        numberOfProductsToDisplay: number;
    };
    forceLoad?: boolean;
    excludeProductId?: string;
    isShellEdit?: boolean;
}

interface Props {
    products?: ProductModel[];
    productInfos?: ProductInfo[];
    pricingLoaded?: true;
    errorMessage?: string;
    dataViewHasProducts?: boolean;
}

type HandlerType = Handler<Parameter, Props>;


export const XngRequestVariantChildrenFromApi: HandlerType = props => {
    const temp = props.products?.filter(product => product.isVariantParent === true);
    const storeParentProducts = JSON.parse(JSON.stringify(temp));
    let count = 0;
    storeParentProducts?.forEach(async (product: any) => {
        let variantChildren = getVariantChildrenDataView(props.getState(), product.id).value;
        if (!variantChildren) {
            variantChildren = await executeAwaitableHandlerChain(
                loadVariantChildren,
                { productId: product.id },
                props,
            );
        }
        product['variantChildren'] = variantChildren;
        count++;
    });

    const intervalId = setInterval(() => {
        if (count === storeParentProducts?.length) {
            props.dispatch({
                type: "xRecentlyViewedCarousel/prepareParentProducts",
                recentlyViewedStoreParentProducts: storeParentProducts,
            } as any);
            clearInterval(intervalId);
        }
    }, 100);
};

addToChainAfter(chain, LoadRealTimeInventory, XngRequestVariantChildrenFromApi);
